import { useState } from 'react'
import { Button } from '@/ui/components/'
import { Badge } from '@/ui/components/'
import { Sparkles } from '@/ui/icons'
import type { FeedCard as FeedCardType } from '@/shared/api'
import { FeedRow } from './FeedRow'
import { SetHomeBaseModal } from './SetHomeBaseModal'
import { RANGER_ICON_CHIP } from './AiRecommendationCard'

interface WeekendSuggestionSetupCardProps {
  card: FeedCardType
  onHomeBaseSaved: () => void
}

/** Shown to Pro users who haven't set a home base yet — the prerequisite for weekly weekend-trip suggestions. */
export function WeekendSuggestionSetupCard({ card, onHomeBaseSaved }: WeekendSuggestionSetupCardProps) {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <>
      <FeedRow
        title={card.title}
        subtitle={card.body}
        icon={Sparkles}
        iconChipClassName={RANGER_ICON_CHIP}
        badge={
          <Badge variant="secondary" className="bg-adventure-100 text-adventure-700 dark:bg-adventure-900/40 dark:text-adventure-300">
            Ranger
          </Badge>
        }
        action={
          <Button size="sm" onClick={() => setModalOpen(true)}>
            {card.actionText || 'Set home base'}
          </Button>
        }
      />
      <SetHomeBaseModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSaved={onHomeBaseSaved}
      />
    </>
  )
}
